import { render } from "./LandingPage.vue?vue&type=template&id=10f804f1&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=10f804f1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10f804f1"

export default script